  <bzg-welcome-landing topTitle="{{ 'AUTOADMIN.TOP_TITLE' | translate }}" middleTitle="{{ 'AUTOADMIN.MIDDLE_TITLE' | translate }}" bottomTitle="{{ 'AUTOADMIN.BOTTOM_TITLE' | translate }}">
    <form #sendEmailForm="ngForm" class="bmc-send-admin-email">
        <p class="bmc-send-admin-email__paragraph">{{ 'AUTOADMIN.SEND_ADMIN_EMAIL_DESCRIPTION' | translate }}</p>
        <bzg-input [(ngModel)]='userEmail' placeholder="{{ 'AUTOADMIN.EMAIL' | translate }}" name="userEmailInput" 
            infoText="{{ 'AUTOADMIN.ONLY_REGISTERED_USERS' | translate }}" [pattern]="EMAIL_REGEXP">
            {{ 'AUTOADMIN.USER_NAME' | translate }}
            <bzg-pattern-error>{{'GLOBAL.PLEASE_ENTER_A_VALID_EMAIL' | translate}}</bzg-pattern-error>
        </bzg-input>
    </form>
    <div class="bmc-send-admin-email__buttons">
        <bzg-button-primary (click)="sendEmail()">{{ 'AUTOADMIN.SEND_EMAIL' | translate }}</bzg-button-primary>
    </div>
  </bzg-welcome-landing>
